import {
  del,
  get,
  post,
  patch,
} from './helper';

export const createMenu = async (storeId, menu) => {
  const res = await post({
    url: `admin/stores/${storeId}/menus`,
    data: menu,
  });
  return res?.data || res;
};

export const deleteMenu = async (storeId, menuId) => {
  const res = await del({
    url: `admin/stores/${storeId}/menus/${menuId}`,
  });
  return res?.data || res;
};

export const getMenu = async (storeId, menuId) => {
  const res = await get({
    url: `admin/stores/${storeId}/menus/${menuId}`,
  });
  return res?.data || res;
};

export const getMenuList = async (storeId) => {
  const res = await get({
    url: `admin/stores/${storeId}/menus`,
  });
  return res?.data || res;
};

export const updateMenu = async (storeId, menuId, menu) => {
  const res = await patch({
    url: `admin/stores/${storeId}/menus/${menuId}`,
    data: menu,
  });
  return res?.data || res;
};

export default {
  createMenu,
  deleteMenu,
  getMenu,
  getMenuList,
  updateMenu,
};
